export const minuteInSeconds = 60;

export const hourInSeconds = 60 * minuteInSeconds;

export const dayInSeconds = 24 * hourInSeconds;
